function csvToArray(str, noHeader=false,quote="\"",delimiter = ",") {
  /// ヘッダー行の値配列を取得
  const headers = str.split('\n')[0].split(delimiter)
 
  /// 各行のテキスト配列を取得
  const rows = str.slice(str.indexOf("\n") + 1)
            .split(/\n|\r\n|\r/)
 
  /// 各行の値配列・オブジェクトの配列に変換
  /// noHeaderがfalseならヘッダーカラム名付きで、
  /// trueならカラム名なしの配列として返す
  const arr = rows.map(function (row) {
    const values = row.split(quote+delimiter+quote);
    const el = headers.reduce(
      function (obj, header, i) {
        const v = values[i].replaceAll('\"',"")
        if(noHeader){
          obj.push(v)
        }else{
          obj[header] = v;
        }
        return obj;
      }, (noHeader) ? [] : {}
    );
    return el;
  });
 
  // return the array
  return arr;
}
